// This file is auto-generated by @hey-api/openapi-ts

export const ArenaSchema = {
    properties: {
        arenaId: {
            type: 'integer',
            title: 'Arenaid'
        },
        arenaName: {
            type: 'string',
            title: 'Arenaname'
        },
        arenaCity: {
            type: 'string',
            title: 'Arenacity'
        },
        arenaState: {
            type: 'string',
            title: 'Arenastate'
        },
        arenaCountry: {
            type: 'string',
            title: 'Arenacountry'
        },
        arenaTimezone: {
            type: 'string',
            title: 'Arenatimezone'
        }
    },
    type: 'object',
    required: ['arenaId', 'arenaName', 'arenaCity', 'arenaState', 'arenaCountry', 'arenaTimezone'],
    title: 'Arena'
} as const;

export const BatchGamePBPRequestSchema = {
    properties: {
        cursor: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cursor',
            description: 'Cursor for pagination'
        },
        limit: {
            type: 'integer',
            maximum: 100,
            exclusiveMinimum: 0,
            title: 'Limit',
            description: 'Max items to return',
            default: 20
        },
        order: {
            type: 'string',
            enum: ['asc', 'desc'],
            title: 'Order',
            description: 'Sort order: asc (oldest first) or desc (newest first)',
            default: 'desc'
        },
        queries: {
            items: {
                '$ref': '#/components/schemas/GameSubQuery'
            },
            type: 'array',
            title: 'Queries'
        }
    },
    type: 'object',
    title: 'BatchGamePBPRequest'
} as const;

export const BatchPlayerPBPRequestSchema = {
    properties: {
        cursor: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cursor',
            description: 'Cursor for pagination'
        },
        limit: {
            type: 'integer',
            maximum: 100,
            exclusiveMinimum: 0,
            title: 'Limit',
            description: 'Max items to return',
            default: 20
        },
        order: {
            type: 'string',
            enum: ['asc', 'desc'],
            title: 'Order',
            description: 'Sort order: asc (oldest first) or desc (newest first)',
            default: 'desc'
        },
        queries: {
            items: {
                '$ref': '#/components/schemas/PlayerSubQuery'
            },
            type: 'array',
            title: 'Queries'
        }
    },
    type: 'object',
    title: 'BatchPlayerPBPRequest'
} as const;

export const BoxPlayerSchema = {
    properties: {
        status: {
            type: 'string',
            title: 'Status'
        },
        order: {
            type: 'integer',
            title: 'Order'
        },
        personId: {
            type: 'integer',
            title: 'Personid'
        },
        jerseyNum: {
            type: 'string',
            title: 'Jerseynum'
        },
        position: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Position'
        },
        starter: {
            type: 'string',
            title: 'Starter'
        },
        oncourt: {
            type: 'string',
            title: 'Oncourt'
        },
        played: {
            type: 'string',
            title: 'Played'
        },
        statistics: {
            anyOf: [
                {
                    '$ref': '#/components/schemas/PlayerStatistics'
                },
                {
                    type: 'null'
                }
            ]
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        nameI: {
            type: 'string',
            title: 'Namei'
        },
        firstName: {
            type: 'string',
            title: 'Firstname'
        },
        familyName: {
            type: 'string',
            title: 'Familyname'
        }
    },
    type: 'object',
    required: ['status', 'order', 'personId', 'jerseyNum', 'starter', 'oncourt', 'played', 'name', 'nameI', 'firstName', 'familyName'],
    title: 'BoxPlayer'
} as const;

export const BoxTeamSchema = {
    properties: {
        teamId: {
            type: 'integer',
            title: 'Teamid'
        },
        teamName: {
            type: 'string',
            title: 'Teamname'
        },
        teamCity: {
            type: 'string',
            title: 'Teamcity'
        },
        teamTricode: {
            type: 'string',
            title: 'Teamtricode'
        },
        score: {
            type: 'integer',
            title: 'Score'
        },
        inBonus: {
            type: 'string',
            title: 'Inbonus'
        },
        timeoutsRemaining: {
            type: 'integer',
            title: 'Timeoutsremaining'
        },
        periods: {
            items: {
                '$ref': '#/components/schemas/Period'
            },
            type: 'array',
            title: 'Periods'
        },
        players: {
            items: {
                '$ref': '#/components/schemas/BoxPlayer'
            },
            type: 'array',
            title: 'Players'
        },
        statistics: {
            '$ref': '#/components/schemas/TeamStatistics'
        }
    },
    type: 'object',
    required: ['teamId', 'teamName', 'teamCity', 'teamTricode', 'score', 'inBonus', 'timeoutsRemaining', 'periods', 'players', 'statistics'],
    title: 'BoxTeam'
} as const;

export const BoxscoreSchema = {
    properties: {
        gameId: {
            type: 'string',
            title: 'Gameid'
        },
        gameTimeLocal: {
            type: 'string',
            title: 'Gametimelocal'
        },
        gameTimeUtc: {
            type: 'string',
            title: 'Gametimeutc'
        },
        gameTimeHome: {
            type: 'string',
            title: 'Gametimehome'
        },
        gameTimeAway: {
            type: 'string',
            title: 'Gametimeaway'
        },
        gameEt: {
            type: 'string',
            title: 'Gameet'
        },
        duration: {
            type: 'integer',
            title: 'Duration'
        },
        gameCode: {
            type: 'string',
            title: 'Gamecode'
        },
        gameStatusText: {
            type: 'string',
            title: 'Gamestatustext'
        },
        gameStatus: {
            type: 'integer',
            title: 'Gamestatus'
        },
        regulationPeriods: {
            type: 'integer',
            title: 'Regulationperiods'
        },
        period: {
            type: 'integer',
            title: 'Period'
        },
        gameClock: {
            type: 'string',
            title: 'Gameclock'
        },
        attendance: {
            type: 'integer',
            title: 'Attendance'
        },
        sellout: {
            type: 'string',
            title: 'Sellout'
        },
        arena: {
            '$ref': '#/components/schemas/Arena'
        },
        officials: {
            items: {
                '$ref': '#/components/schemas/Official'
            },
            type: 'array',
            title: 'Officials'
        },
        homeTeam: {
            '$ref': '#/components/schemas/BoxTeam'
        },
        awayTeam: {
            '$ref': '#/components/schemas/BoxTeam'
        }
    },
    type: 'object',
    required: ['gameId', 'gameTimeLocal', 'gameTimeUtc', 'gameTimeHome', 'gameTimeAway', 'gameEt', 'duration', 'gameCode', 'gameStatusText', 'gameStatus', 'regulationPeriods', 'period', 'gameClock', 'attendance', 'sellout', 'arena', 'officials', 'homeTeam', 'awayTeam'],
    title: 'Boxscore'
} as const;

export const GameSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        date: {
            type: 'string',
            format: 'date-time',
            title: 'Date'
        },
        matchup: {
            type: 'string',
            title: 'Matchup'
        },
        seasonId: {
            type: 'string',
            title: 'Seasonid'
        },
        homeTeamId: {
            type: 'string',
            title: 'Hometeamid'
        },
        homeTeam: {
            type: 'string',
            title: 'Hometeam'
        },
        homeAbbv: {
            type: 'string',
            title: 'Homeabbv'
        },
        awayTeamId: {
            type: 'string',
            title: 'Awayteamid'
        },
        awayTeam: {
            type: 'string',
            title: 'Awayteam'
        },
        awayAbbv: {
            type: 'string',
            title: 'Awayabbv'
        },
        min: {
            type: 'integer',
            title: 'Min'
        },
        videoAvailable: {
            type: 'boolean',
            title: 'Videoavailable'
        },
        teamStats: {
            additionalProperties: {
                '$ref': '#/components/schemas/GameStats'
            },
            type: 'object',
            title: 'Teamstats'
        }
    },
    type: 'object',
    required: ['id', 'date', 'matchup', 'seasonId', 'homeTeamId', 'homeTeam', 'homeAbbv', 'awayTeamId', 'awayTeam', 'awayAbbv', 'min', 'videoAvailable', 'teamStats'],
    title: 'Game'
} as const;

export const GameStatsSchema = {
    properties: {
        pts: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Pts'
        },
        ast: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ast'
        },
        reb: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reb'
        },
        dreb: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Dreb'
        },
        oreb: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Oreb'
        },
        stl: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Stl'
        },
        blk: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Blk'
        },
        tov: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tov'
        },
        fg3A: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fg3A'
        },
        fg3M: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fg3M'
        },
        fg3Pct: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fg3Pct'
        },
        fga: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fga'
        },
        fgm: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fgm'
        },
        fgPct: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fgpct'
        },
        fta: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fta'
        },
        ftm: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ftm'
        },
        ftPct: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ftpct'
        },
        pf: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Pf'
        },
        plusMinus: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Plusminus'
        },
        wl: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Wl'
        }
    },
    type: 'object',
    required: ['pts', 'ast', 'reb', 'dreb', 'oreb', 'stl', 'blk', 'tov', 'fg3A', 'fg3M', 'fg3Pct', 'fga', 'fgm', 'fgPct', 'fta', 'ftm', 'ftPct', 'pf', 'plusMinus', 'wl'],
    title: 'GameStats'
} as const;

export const GameSubQuerySchema = {
    properties: {
        seasonType: {
            '$ref': '#/components/schemas/SeasonType',
            default: 'Regular Season'
        },
        contexts: {
            items: {
                '$ref': '#/components/schemas/Stat'
            },
            type: 'array',
            title: 'Contexts',
            default: []
        },
        players: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Players'
        },
        periods: {
            items: {
                type: 'integer'
            },
            type: 'array',
            title: 'Periods'
        },
        gameId: {
            type: 'string',
            title: 'Gameid'
        }
    },
    type: 'object',
    required: ['gameId'],
    title: 'GameSubQuery'
} as const;

export const HTTPValidationErrorSchema = {
    properties: {
        detail: {
            items: {
                '$ref': '#/components/schemas/ValidationError'
            },
            type: 'array',
            title: 'Detail'
        }
    },
    type: 'object',
    title: 'HTTPValidationError'
} as const;

export const LeagueLeaderSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        stat: {
            type: 'string',
            title: 'Stat'
        },
        rank: {
            type: 'integer',
            title: 'Rank'
        },
        teamId: {
            type: 'string',
            title: 'Teamid'
        },
        teamName: {
            type: 'string',
            title: 'Teamname'
        },
        teamAbbv: {
            type: 'string',
            title: 'Teamabbv'
        },
        value: {
            type: 'number',
            title: 'Value'
        }
    },
    type: 'object',
    required: ['id', 'name', 'stat', 'rank', 'teamId', 'teamName', 'teamAbbv', 'value'],
    title: 'LeagueLeader'
} as const;

export const LiveGameScoreSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        gameStatus: {
            type: 'integer',
            title: 'Gamestatus'
        },
        gameStatusText: {
            type: 'string',
            title: 'Gamestatustext'
        },
        period: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Period'
        },
        gameClock: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Gameclock'
        },
        isLive: {
            type: 'boolean',
            title: 'Islive',
            default: false
        },
        homeScore: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Homescore'
        },
        awayScore: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Awayscore'
        },
        lastPlay: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lastplay'
        }
    },
    type: 'object',
    required: ['id', 'gameStatus', 'gameStatusText'],
    title: 'LiveGameScore'
} as const;

export const NBASeasonSchema = {
    type: 'string',
    enum: ['2026-27', '2025-26', '2024-25', '2023-24', '2022-23', '2021-22', '2020-21', '2019-20', '2018-19', '2017-18', '2016-17', '2015-16', '2014-15', '2013-14', '2012-13', '2011-12', '2010-11', '2009-10', '2008-09', '2007-08', '2006-07', '2005-06', '2004-05', '2003-04', '2002-03', '2001-02', '2000-01', '1999-00', '1998-99', '1997-98', '1996-97', '1995-96', '1994-95', '1993-94', '1992-93', '1991-92', '1990-91', '1989-90', '1988-89', '1987-88', '1986-87', '1985-86', '1984-85', '1983-84', '1982-83', '1981-82', '1980-81', '1979-80', '1978-79', '1977-78', '1976-77', '1975-76', '1974-75', '1973-74', '1972-73', '1971-72', '1970-71', '1969-70', '1968-69', '1967-68', '1966-67', '1965-66', '1964-65', '1963-64', '1962-63', '1961-62', '1960-61', '1959-60', '1958-59', '1957-58', '1956-57', '1955-56', '1954-55', '1953-54', '1952-53', '1951-52', '1950-51', '1949-50', '1948-49', '1947-48', '1946-47'],
    title: 'NBASeason'
} as const;

export const OfficialSchema = {
    properties: {
        personId: {
            type: 'integer',
            title: 'Personid'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        nameI: {
            type: 'string',
            title: 'Namei'
        },
        firstName: {
            type: 'string',
            title: 'Firstname'
        },
        familyName: {
            type: 'string',
            title: 'Familyname'
        },
        jerseyNum: {
            type: 'string',
            title: 'Jerseynum'
        },
        assignment: {
            type: 'string',
            title: 'Assignment'
        }
    },
    type: 'object',
    required: ['personId', 'name', 'nameI', 'firstName', 'familyName', 'jerseyNum', 'assignment'],
    title: 'Official'
} as const;

export const PaginationResponse_list_VideoEvent__Schema = {
    properties: {
        nextCursor: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Nextcursor',
            description: ''
        },
        items: {
            items: {
                '$ref': '#/components/schemas/VideoEvent'
            },
            type: 'array',
            title: 'Items',
            description: 'items'
        },
        total: {
            type: 'integer',
            title: 'Total',
            description: 'Total elements'
        },
        errors: {
            items: {
                type: 'object'
            },
            type: 'array',
            title: 'Errors'
        }
    },
    type: 'object',
    required: ['nextCursor', 'items', 'total'],
    title: 'PaginationResponse[list[VideoEvent]]'
} as const;

export const PeriodSchema = {
    properties: {
        period: {
            type: 'integer',
            title: 'Period'
        },
        periodType: {
            type: 'string',
            title: 'Periodtype'
        },
        score: {
            type: 'integer',
            title: 'Score'
        }
    },
    type: 'object',
    required: ['period', 'periodType', 'score'],
    title: 'Period'
} as const;

export const PlayerSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        firstName: {
            type: 'string',
            title: 'Firstname'
        },
        lastName: {
            type: 'string',
            title: 'Lastname'
        },
        fullName: {
            type: 'string',
            title: 'Fullname'
        },
        isActive: {
            type: 'boolean',
            title: 'Isactive'
        },
        fromYear: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fromyear'
        },
        toYear: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Toyear'
        },
        teamId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Teamid'
        },
        teamAbbreviation: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Teamabbreviation'
        }
    },
    type: 'object',
    required: ['id', 'firstName', 'lastName', 'fullName', 'isActive'],
    title: 'Player'
} as const;

export const PlayerStatisticsSchema = {
    properties: {
        assists: {
            type: 'integer',
            title: 'Assists'
        },
        blocks: {
            type: 'integer',
            title: 'Blocks'
        },
        blocksReceived: {
            type: 'integer',
            title: 'Blocksreceived'
        },
        fieldGoalsAttempted: {
            type: 'integer',
            title: 'Fieldgoalsattempted'
        },
        fieldGoalsMade: {
            type: 'integer',
            title: 'Fieldgoalsmade'
        },
        fieldGoalsPercentage: {
            type: 'number',
            title: 'Fieldgoalspercentage'
        },
        foulsOffensive: {
            type: 'integer',
            title: 'Foulsoffensive'
        },
        foulsDrawn: {
            type: 'integer',
            title: 'Foulsdrawn'
        },
        foulsPersonal: {
            type: 'integer',
            title: 'Foulspersonal'
        },
        foulsTechnical: {
            type: 'integer',
            title: 'Foulstechnical'
        },
        freeThrowsAttempted: {
            type: 'integer',
            title: 'Freethrowsattempted'
        },
        freeThrowsMade: {
            type: 'integer',
            title: 'Freethrowsmade'
        },
        freeThrowsPercentage: {
            type: 'number',
            title: 'Freethrowspercentage'
        },
        minus: {
            type: 'number',
            title: 'Minus'
        },
        minutes: {
            type: 'string',
            title: 'Minutes'
        },
        minutesCalculated: {
            type: 'string',
            title: 'Minutescalculated'
        },
        plus: {
            type: 'number',
            title: 'Plus'
        },
        plusMinusPoints: {
            type: 'number',
            title: 'Plusminuspoints'
        },
        points: {
            type: 'integer',
            title: 'Points'
        },
        pointsFastBreak: {
            type: 'integer',
            title: 'Pointsfastbreak'
        },
        pointsInThePaint: {
            type: 'integer',
            title: 'Pointsinthepaint'
        },
        pointsSecondChance: {
            type: 'integer',
            title: 'Pointssecondchance'
        },
        reboundsDefensive: {
            type: 'integer',
            title: 'Reboundsdefensive'
        },
        reboundsOffensive: {
            type: 'integer',
            title: 'Reboundsoffensive'
        },
        reboundsTotal: {
            type: 'integer',
            title: 'Reboundstotal'
        },
        steals: {
            type: 'integer',
            title: 'Steals'
        },
        threePointersAttempted: {
            type: 'integer',
            title: 'Threepointersattempted'
        },
        threePointersMade: {
            type: 'integer',
            title: 'Threepointersmade'
        },
        threePointersPercentage: {
            type: 'number',
            title: 'Threepointerspercentage'
        },
        turnovers: {
            type: 'integer',
            title: 'Turnovers'
        },
        twoPointersAttempted: {
            type: 'integer',
            title: 'Twopointersattempted'
        },
        twoPointersMade: {
            type: 'integer',
            title: 'Twopointersmade'
        },
        twoPointersPercentage: {
            type: 'number',
            title: 'Twopointerspercentage'
        }
    },
    type: 'object',
    required: ['assists', 'blocks', 'blocksReceived', 'fieldGoalsAttempted', 'fieldGoalsMade', 'fieldGoalsPercentage', 'foulsOffensive', 'foulsDrawn', 'foulsPersonal', 'foulsTechnical', 'freeThrowsAttempted', 'freeThrowsMade', 'freeThrowsPercentage', 'minus', 'minutes', 'minutesCalculated', 'plus', 'plusMinusPoints', 'points', 'pointsFastBreak', 'pointsInThePaint', 'pointsSecondChance', 'reboundsDefensive', 'reboundsOffensive', 'reboundsTotal', 'steals', 'threePointersAttempted', 'threePointersMade', 'threePointersPercentage', 'turnovers', 'twoPointersAttempted', 'twoPointersMade', 'twoPointersPercentage'],
    title: 'PlayerStatistics'
} as const;

export const PlayerSubQuerySchema = {
    properties: {
        lastNGames: {
            type: 'integer',
            title: 'Lastngames',
            default: 0
        },
        contexts: {
            items: {
                '$ref': '#/components/schemas/Stat'
            },
            type: 'array',
            title: 'Contexts',
            default: ['PTS']
        },
        seasons: {
            items: {
                '$ref': '#/components/schemas/Season'
            },
            type: 'array',
            title: 'Seasons',
            default: ['2026-27']
        },
        seasonType: {
            '$ref': '#/components/schemas/SeasonType',
            default: 'Regular Season'
        },
        opponentTeamId: {
            type: 'string',
            title: 'Opponentteamid',
            default: '0'
        },
        dateFrom: {
            type: 'string',
            title: 'Datefrom',
            default: ''
        },
        dateTo: {
            type: 'string',
            title: 'Dateto',
            default: ''
        },
        periods: {
            items: {
                type: 'integer'
            },
            type: 'array',
            title: 'Periods'
        },
        playerId: {
            type: 'string',
            title: 'Playerid'
        }
    },
    type: 'object',
    required: ['playerId'],
    title: 'PlayerSubQuery'
} as const;

export const PlaylistSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        description: {
            type: 'string',
            title: 'Description'
        },
        isOwner: {
            type: 'boolean',
            title: 'Isowner'
        },
        private: {
            type: 'boolean',
            title: 'Private'
        },
        thumbnailUrl: {
            type: 'string',
            title: 'Thumbnailurl'
        },
        videoCount: {
            type: 'integer',
            title: 'Videocount'
        },
        totalDuration: {
            type: 'integer',
            title: 'Totalduration'
        },
        createdAt: {
            type: 'string',
            format: 'date-time',
            title: 'Createdat'
        },
        updatedAt: {
            type: 'string',
            format: 'date-time',
            title: 'Updatedat'
        },
        videos: {
            items: {
                '$ref': '#/components/schemas/PlaylistVideo'
            },
            type: 'array',
            title: 'Videos'
        }
    },
    type: 'object',
    required: ['id', 'name', 'description', 'isOwner', 'private', 'thumbnailUrl', 'videoCount', 'totalDuration', 'createdAt', 'updatedAt', 'videos'],
    title: 'Playlist'
} as const;

export const PlaylistParamsSchema = {
    properties: {
        name: {
            type: 'string',
            title: 'Name'
        },
        description: {
            type: 'string',
            title: 'Description'
        },
        private: {
            type: 'boolean',
            title: 'Private'
        },
        thumbnailUrl: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Thumbnailurl',
            default: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSjeDntDIAsDKAc6Fl7t9iBgQAyxwkSCSrVpQ&s'
        }
    },
    type: 'object',
    required: ['name', 'description', 'private'],
    title: 'PlaylistParams'
} as const;

export const PlaylistVideoSchema = {
    properties: {
        url: {
            type: 'string',
            title: 'Url'
        },
        gameId: {
            type: 'string',
            title: 'Gameid'
        },
        playerId: {
            type: 'string',
            title: 'Playerid'
        },
        playerName: {
            type: 'string',
            title: 'Playername'
        },
        playerTeamId: {
            type: 'string',
            title: 'Playerteamid'
        },
        player2Id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Player2Id'
        },
        player2Name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Player2Name'
        },
        player2TeamId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Player2Teamid'
        },
        player3Id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Player3Id'
        },
        player3Name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Player3Name'
        },
        player3TeamId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Player3Teamid'
        },
        score: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Score'
        },
        clockTime: {
            type: 'string',
            title: 'Clocktime'
        },
        eventNumber: {
            type: 'integer',
            title: 'Eventnumber'
        },
        desc: {
            type: 'string',
            title: 'Desc'
        },
        gamecode: {
            type: 'string',
            title: 'Gamecode'
        },
        date: {
            type: 'string',
            format: 'date-time',
            title: 'Date'
        },
        period: {
            type: 'integer',
            title: 'Period'
        },
        hAbbv: {
            type: 'string',
            title: 'Habbv'
        },
        hTeamId: {
            type: 'string',
            title: 'Hteamid'
        },
        hPointBefore: {
            type: 'integer',
            title: 'Hpointbefore'
        },
        hPointAfter: {
            type: 'integer',
            title: 'Hpointafter'
        },
        vAbbv: {
            type: 'string',
            title: 'Vabbv'
        },
        vTeamId: {
            type: 'string',
            title: 'Vteamid'
        },
        vPointBefore: {
            type: 'integer',
            title: 'Vpointbefore'
        },
        vPointAfter: {
            type: 'integer',
            title: 'Vpointafter'
        },
        pta: {
            type: 'string',
            title: 'Pta'
        },
        tags: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Tags'
        },
        id: {
            type: 'string',
            title: 'Id'
        },
        position: {
            type: 'integer',
            title: 'Position'
        },
        playlistId: {
            type: 'string',
            title: 'Playlistid'
        },
        videoThumbnail: {
            type: 'string',
            title: 'Videothumbnail'
        },
        videoDuration: {
            type: 'integer',
            title: 'Videoduration'
        },
        addedAt: {
            type: 'string',
            format: 'date-time',
            title: 'Addedat'
        }
    },
    type: 'object',
    required: ['url', 'gameId', 'playerId', 'playerName', 'playerTeamId', 'score', 'clockTime', 'eventNumber', 'desc', 'gamecode', 'date', 'period', 'hAbbv', 'hTeamId', 'hPointBefore', 'hPointAfter', 'vAbbv', 'vTeamId', 'vPointBefore', 'vPointAfter', 'pta', 'tags', 'id', 'position', 'playlistId', 'videoThumbnail', 'videoDuration', 'addedAt'],
    title: 'PlaylistVideo'
} as const;

export const PlaylistVideoParamsSchema = {
    properties: {
        url: {
            type: 'string',
            title: 'Url'
        },
        gameId: {
            type: 'string',
            title: 'Gameid'
        },
        playerId: {
            type: 'string',
            title: 'Playerid'
        },
        playerName: {
            type: 'string',
            title: 'Playername'
        },
        playerTeamId: {
            type: 'string',
            title: 'Playerteamid'
        },
        player2Id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Player2Id'
        },
        player2Name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Player2Name'
        },
        player2TeamId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Player2Teamid'
        },
        player3Id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Player3Id'
        },
        player3Name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Player3Name'
        },
        player3TeamId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Player3Teamid'
        },
        score: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Score'
        },
        clockTime: {
            type: 'string',
            title: 'Clocktime'
        },
        eventNumber: {
            type: 'integer',
            title: 'Eventnumber'
        },
        desc: {
            type: 'string',
            title: 'Desc'
        },
        gamecode: {
            type: 'string',
            title: 'Gamecode'
        },
        date: {
            type: 'string',
            format: 'date-time',
            title: 'Date'
        },
        period: {
            type: 'integer',
            title: 'Period'
        },
        hAbbv: {
            type: 'string',
            title: 'Habbv'
        },
        hTeamId: {
            type: 'string',
            title: 'Hteamid'
        },
        hPointBefore: {
            type: 'integer',
            title: 'Hpointbefore'
        },
        hPointAfter: {
            type: 'integer',
            title: 'Hpointafter'
        },
        vAbbv: {
            type: 'string',
            title: 'Vabbv'
        },
        vTeamId: {
            type: 'string',
            title: 'Vteamid'
        },
        vPointBefore: {
            type: 'integer',
            title: 'Vpointbefore'
        },
        vPointAfter: {
            type: 'integer',
            title: 'Vpointafter'
        },
        pta: {
            type: 'string',
            title: 'Pta'
        },
        tags: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Tags'
        },
        videoThumbnail: {
            type: 'string',
            title: 'Videothumbnail'
        },
        videoDuration: {
            type: 'integer',
            title: 'Videoduration'
        }
    },
    type: 'object',
    required: ['url', 'gameId', 'playerId', 'playerName', 'playerTeamId', 'score', 'clockTime', 'eventNumber', 'desc', 'gamecode', 'date', 'period', 'hAbbv', 'hTeamId', 'hPointBefore', 'hPointAfter', 'vAbbv', 'vTeamId', 'vPointBefore', 'vPointAfter', 'pta', 'tags', 'videoThumbnail', 'videoDuration'],
    title: 'PlaylistVideoParams'
} as const;

export const ScheduleGameSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        gameCode: {
            type: 'string',
            title: 'Gamecode'
        },
        gameStatus: {
            type: 'integer',
            title: 'Gamestatus'
        },
        gameStatusText: {
            type: 'string',
            title: 'Gamestatustext'
        },
        period: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Period'
        },
        gameClock: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Gameclock'
        },
        isLive: {
            type: 'boolean',
            title: 'Islive',
            default: false
        },
        lastPlay: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lastplay'
        },
        date: {
            type: 'string',
            format: 'date-time',
            title: 'Date'
        },
        gameDateEst: {
            type: 'string',
            title: 'Gamedateest'
        },
        gameTimeEst: {
            type: 'string',
            title: 'Gametimeest'
        },
        arenaName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Arenaname'
        },
        arenaCity: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Arenacity'
        },
        arenaState: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Arenastate'
        },
        homeTeam: {
            '$ref': '#/components/schemas/ScheduleGameTeam'
        },
        awayTeam: {
            '$ref': '#/components/schemas/ScheduleGameTeam'
        },
        broadcasters: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Broadcasters',
            default: []
        },
        gameLabel: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Gamelabel'
        },
        gameSubLabel: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Gamesublabel'
        },
        seriesText: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Seriestext'
        },
        seasonStage: {
            '$ref': '#/components/schemas/SeasonStage',
            default: 'Regular Season'
        },
        gameUrl: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Gameurl'
        }
    },
    type: 'object',
    required: ['id', 'gameCode', 'gameStatus', 'gameStatusText', 'date', 'gameDateEst', 'gameTimeEst', 'homeTeam', 'awayTeam'],
    title: 'ScheduleGame'
} as const;

export const ScheduleGameTeamSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        city: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'City'
        },
        abbv: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Abbv'
        },
        wins: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Wins'
        },
        losses: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Losses'
        },
        score: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Score'
        },
        isTbd: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Istbd',
            default: false
        },
        possibleTeams: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Possibleteams',
            default: []
        }
    },
    type: 'object',
    required: ['id'],
    title: 'ScheduleGameTeam'
} as const;

export const SeasonSchema = {
    anyOf: [
        {
            '$ref': '#/components/schemas/NBASeason'
        },
        {
            '$ref': '#/components/schemas/WNBASeason'
        }
    ]
} as const;

export const SeasonStageSchema = {
    type: 'string',
    enum: ['Preseason', 'Regular Season', "Commissioner's Cup", 'Emirates NBA Cup', 'Playoffs', 'Finals', 'Play-In', 'All-Star'],
    title: 'SeasonStage'
} as const;

export const SeasonTypeSchema = {
    type: 'string',
    enum: ['Regular Season', 'Playoffs'],
    title: 'SeasonType'
} as const;

export const StatSchema = {
    type: 'string',
    enum: ['PTS', 'FGM', 'FGA', 'FG3M', 'FG3A', 'REB', 'AST', 'FGM_AST', 'FG3_AST', 'STL', 'BLK', 'TOV'],
    title: 'Stat'
} as const;

export const TeamSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        abbreviation: {
            type: 'string',
            title: 'Abbreviation'
        },
        city: {
            type: 'string',
            title: 'City'
        },
        fullName: {
            type: 'string',
            title: 'Fullname'
        },
        nickname: {
            type: 'string',
            title: 'Nickname'
        },
        state: {
            type: 'string',
            title: 'State'
        },
        yearFounded: {
            type: 'integer',
            title: 'Yearfounded'
        }
    },
    type: 'object',
    required: ['id', 'abbreviation', 'city', 'fullName', 'nickname', 'state', 'yearFounded'],
    title: 'Team'
} as const;

export const TeamStandingSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        city: {
            type: 'string',
            title: 'City'
        },
        conference: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Conference'
        },
        wins: {
            type: 'integer',
            title: 'Wins'
        },
        losses: {
            type: 'integer',
            title: 'Losses'
        },
        winPct: {
            type: 'number',
            title: 'Winpct'
        },
        record: {
            type: 'string',
            title: 'Record'
        },
        l10: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'L10'
        },
        currentStreak: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Currentstreak'
        }
    },
    type: 'object',
    required: ['id', 'name', 'city', 'wins', 'losses', 'winPct', 'record'],
    title: 'TeamStanding'
} as const;

export const TeamStatisticsSchema = {
    properties: {
        assists: {
            type: 'integer',
            title: 'Assists'
        },
        assistsTurnoverRatio: {
            type: 'number',
            title: 'Assiststurnoverratio'
        },
        benchPoints: {
            type: 'integer',
            title: 'Benchpoints'
        },
        biggestLead: {
            type: 'integer',
            title: 'Biggestlead'
        },
        biggestLeadScore: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Biggestleadscore'
        },
        biggestScoringRun: {
            type: 'integer',
            title: 'Biggestscoringrun'
        },
        biggestScoringRunScore: {
            type: 'string',
            title: 'Biggestscoringrunscore'
        },
        blocks: {
            type: 'integer',
            title: 'Blocks'
        },
        blocksReceived: {
            type: 'integer',
            title: 'Blocksreceived'
        },
        fastBreakPointsAttempted: {
            type: 'integer',
            title: 'Fastbreakpointsattempted'
        },
        fastBreakPointsMade: {
            type: 'integer',
            title: 'Fastbreakpointsmade'
        },
        fastBreakPointsPercentage: {
            type: 'number',
            title: 'Fastbreakpointspercentage'
        },
        fieldGoalsAttempted: {
            type: 'integer',
            title: 'Fieldgoalsattempted'
        },
        fieldGoalsEffectiveAdjusted: {
            type: 'number',
            title: 'Fieldgoalseffectiveadjusted'
        },
        fieldGoalsMade: {
            type: 'integer',
            title: 'Fieldgoalsmade'
        },
        fieldGoalsPercentage: {
            type: 'number',
            title: 'Fieldgoalspercentage'
        },
        foulsOffensive: {
            type: 'integer',
            title: 'Foulsoffensive'
        },
        foulsDrawn: {
            type: 'integer',
            title: 'Foulsdrawn'
        },
        foulsPersonal: {
            type: 'integer',
            title: 'Foulspersonal'
        },
        foulsTeam: {
            type: 'integer',
            title: 'Foulsteam'
        },
        foulsTechnical: {
            type: 'integer',
            title: 'Foulstechnical'
        },
        foulsTeamTechnical: {
            type: 'integer',
            title: 'Foulsteamtechnical'
        },
        freeThrowsAttempted: {
            type: 'integer',
            title: 'Freethrowsattempted'
        },
        freeThrowsMade: {
            type: 'integer',
            title: 'Freethrowsmade'
        },
        freeThrowsPercentage: {
            type: 'number',
            title: 'Freethrowspercentage'
        },
        leadChanges: {
            type: 'integer',
            title: 'Leadchanges'
        },
        minutes: {
            type: 'string',
            title: 'Minutes'
        },
        minutesCalculated: {
            type: 'string',
            title: 'Minutescalculated'
        },
        points: {
            type: 'integer',
            title: 'Points'
        },
        pointsAgainst: {
            type: 'integer',
            title: 'Pointsagainst'
        },
        pointsFastBreak: {
            type: 'integer',
            title: 'Pointsfastbreak'
        },
        pointsFromTurnovers: {
            type: 'integer',
            title: 'Pointsfromturnovers'
        },
        pointsInThePaint: {
            type: 'integer',
            title: 'Pointsinthepaint'
        },
        pointsInThePaintAttempted: {
            type: 'integer',
            title: 'Pointsinthepaintattempted'
        },
        pointsInThePaintMade: {
            type: 'integer',
            title: 'Pointsinthepaintmade'
        },
        pointsInThePaintPercentage: {
            type: 'number',
            title: 'Pointsinthepaintpercentage'
        },
        pointsSecondChance: {
            type: 'integer',
            title: 'Pointssecondchance'
        },
        reboundsDefensive: {
            type: 'integer',
            title: 'Reboundsdefensive'
        },
        reboundsOffensive: {
            type: 'integer',
            title: 'Reboundsoffensive'
        },
        reboundsPersonal: {
            type: 'integer',
            title: 'Reboundspersonal'
        },
        reboundsTeam: {
            type: 'integer',
            title: 'Reboundsteam'
        },
        reboundsTeamDefensive: {
            type: 'integer',
            title: 'Reboundsteamdefensive'
        },
        reboundsTeamOffensive: {
            type: 'integer',
            title: 'Reboundsteamoffensive'
        },
        reboundsTotal: {
            type: 'integer',
            title: 'Reboundstotal'
        },
        secondChancePointsAttempted: {
            type: 'integer',
            title: 'Secondchancepointsattempted'
        },
        secondChancePointsMade: {
            type: 'integer',
            title: 'Secondchancepointsmade'
        },
        secondChancePointsPercentage: {
            type: 'number',
            title: 'Secondchancepointspercentage'
        },
        steals: {
            type: 'integer',
            title: 'Steals'
        },
        threePointersAttempted: {
            type: 'integer',
            title: 'Threepointersattempted'
        },
        threePointersMade: {
            type: 'integer',
            title: 'Threepointersmade'
        },
        threePointersPercentage: {
            type: 'number',
            title: 'Threepointerspercentage'
        },
        timeLeading: {
            type: 'string',
            title: 'Timeleading'
        },
        timesTied: {
            type: 'integer',
            title: 'Timestied'
        },
        trueShootingAttempts: {
            type: 'number',
            title: 'Trueshootingattempts'
        },
        trueShootingPercentage: {
            type: 'number',
            title: 'Trueshootingpercentage'
        },
        turnovers: {
            type: 'integer',
            title: 'Turnovers'
        },
        turnoversTeam: {
            type: 'integer',
            title: 'Turnoversteam'
        },
        turnoversTotal: {
            type: 'integer',
            title: 'Turnoverstotal'
        },
        twoPointersAttempted: {
            type: 'integer',
            title: 'Twopointersattempted'
        },
        twoPointersMade: {
            type: 'integer',
            title: 'Twopointersmade'
        },
        twoPointersPercentage: {
            type: 'number',
            title: 'Twopointerspercentage'
        }
    },
    type: 'object',
    required: ['assists', 'assistsTurnoverRatio', 'benchPoints', 'biggestLead', 'biggestScoringRun', 'biggestScoringRunScore', 'blocks', 'blocksReceived', 'fastBreakPointsAttempted', 'fastBreakPointsMade', 'fastBreakPointsPercentage', 'fieldGoalsAttempted', 'fieldGoalsEffectiveAdjusted', 'fieldGoalsMade', 'fieldGoalsPercentage', 'foulsOffensive', 'foulsDrawn', 'foulsPersonal', 'foulsTeam', 'foulsTechnical', 'foulsTeamTechnical', 'freeThrowsAttempted', 'freeThrowsMade', 'freeThrowsPercentage', 'leadChanges', 'minutes', 'minutesCalculated', 'points', 'pointsAgainst', 'pointsFastBreak', 'pointsFromTurnovers', 'pointsInThePaint', 'pointsInThePaintAttempted', 'pointsInThePaintMade', 'pointsInThePaintPercentage', 'pointsSecondChance', 'reboundsDefensive', 'reboundsOffensive', 'reboundsPersonal', 'reboundsTeam', 'reboundsTeamDefensive', 'reboundsTeamOffensive', 'reboundsTotal', 'secondChancePointsAttempted', 'secondChancePointsMade', 'secondChancePointsPercentage', 'steals', 'threePointersAttempted', 'threePointersMade', 'threePointersPercentage', 'timeLeading', 'timesTied', 'trueShootingAttempts', 'trueShootingPercentage', 'turnovers', 'turnoversTeam', 'turnoversTotal', 'twoPointersAttempted', 'twoPointersMade', 'twoPointersPercentage'],
    title: 'TeamStatistics'
} as const;

export const ValidationErrorSchema = {
    properties: {
        loc: {
            items: {
                anyOf: [
                    {
                        type: 'string'
                    },
                    {
                        type: 'integer'
                    }
                ]
            },
            type: 'array',
            title: 'Location'
        },
        msg: {
            type: 'string',
            title: 'Message'
        },
        type: {
            type: 'string',
            title: 'Error Type'
        }
    },
    type: 'object',
    required: ['loc', 'msg', 'type'],
    title: 'ValidationError'
} as const;

export const VideoEventSchema = {
    properties: {
        url: {
            type: 'string',
            title: 'Url'
        },
        gameId: {
            type: 'string',
            title: 'Gameid'
        },
        playerId: {
            type: 'string',
            title: 'Playerid'
        },
        playerName: {
            type: 'string',
            title: 'Playername'
        },
        playerTeamId: {
            type: 'string',
            title: 'Playerteamid'
        },
        player2Id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Player2Id'
        },
        player2Name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Player2Name'
        },
        player2TeamId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Player2Teamid'
        },
        player3Id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Player3Id'
        },
        player3Name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Player3Name'
        },
        player3TeamId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Player3Teamid'
        },
        score: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Score'
        },
        clockTime: {
            type: 'string',
            title: 'Clocktime'
        },
        eventNumber: {
            type: 'integer',
            title: 'Eventnumber'
        },
        desc: {
            type: 'string',
            title: 'Desc'
        },
        gamecode: {
            type: 'string',
            title: 'Gamecode'
        },
        date: {
            type: 'string',
            format: 'date-time',
            title: 'Date'
        },
        period: {
            type: 'integer',
            title: 'Period'
        },
        hAbbv: {
            type: 'string',
            title: 'Habbv'
        },
        hTeamId: {
            type: 'string',
            title: 'Hteamid'
        },
        hPointBefore: {
            type: 'integer',
            title: 'Hpointbefore'
        },
        hPointAfter: {
            type: 'integer',
            title: 'Hpointafter'
        },
        vAbbv: {
            type: 'string',
            title: 'Vabbv'
        },
        vTeamId: {
            type: 'string',
            title: 'Vteamid'
        },
        vPointBefore: {
            type: 'integer',
            title: 'Vpointbefore'
        },
        vPointAfter: {
            type: 'integer',
            title: 'Vpointafter'
        },
        pta: {
            type: 'string',
            title: 'Pta'
        },
        tags: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Tags'
        }
    },
    type: 'object',
    required: ['url', 'gameId', 'playerId', 'playerName', 'playerTeamId', 'score', 'clockTime', 'eventNumber', 'desc', 'gamecode', 'date', 'period', 'hAbbv', 'hTeamId', 'hPointBefore', 'hPointAfter', 'vAbbv', 'vTeamId', 'vPointBefore', 'vPointAfter', 'pta', 'tags'],
    title: 'VideoEvent'
} as const;

export const WNBASeasonSchema = {
    type: 'string',
    enum: ['2026', '2025', '2024', '2023', '2022', '2021', '2020', '2019', '2018', '2017', '2016', '2015', '2014', '2013', '2012', '2011', '2010', '2009', '2008', '2007', '2006', '2005', '2004', '2003', '2002', '2001', '2000', '1999', '1998'],
    title: 'WNBASeason'
} as const;